import styled from 'styled-components';

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0;
    height: 64px;
    max-height: 64px;
    overflow: hidden;
    position: relative;
    align-self: stretch;
    line-height: 64px;
`;

export const UserMenuTrigger = styled.div`
    display: flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
    user-select: none;
    height: 40px;
    max-height: 40px;
    overflow: hidden;
    line-height: 1;
    
    &:hover {
        background-color: rgba(64, 133, 198, 0.08);
        
        svg {
            transform: translateY(1px);
        }
    }
    
    &:active {
        background-color: rgba(64, 133, 198, 0.12);
    }
`;

export const UserInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 0;
    min-width: 0;
`;

export const VersionText = styled.span`
    font-size: 11px;
    color: #8c8c8c;
    letter-spacing: 0.3px;
    font-weight: 400;
`;

 export const Modal = styled.div`
    .modal-div{
        width: 500px;
        height: 200px;
    }
 `

export const CardProfile = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`
export const CardAvatar = styled.div`
    width: 100px;
`

export const CardUserDetails = styled.div`
    float: left;   
`
export const Logo = styled.div`
    .title {
        color: #4085c6;
        font-size: 18px;
        margin-bottom: 0;
        span {
            color: #000;
            font-weight: bold;
        }
    }
`;

